import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  add: false,
  edit: false,
  list: {},
};

const supplierSlice = createSlice({
  name: "suppliers",
  initialState,
  reducers: {
    add(state, action) {
      state.add = action.payload;
    },
    setEditSupplier(state, action) {
      state.edit = action.payload;
    },
    setSuplliers(state, action) {
      state.list = action.payload;
    },
    addSupplierToList(state, action) {
      state.list[action.payload.key] = action.payload.value;
    },
  },
});

export const { add, setEditSupplier, setSuplliers, addSupplierToList } = supplierSlice.actions;
export default supplierSlice.reducer;
